function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallManufacturerGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 214",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 232",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1122",
    d: "M-10447-8644v-5.625h16v5.625zm1.406-1.406h13.188v-2.812h-13.187zm11.146-.937v-.937h1.1v.938zm-2.043 0v-.937h1.105v.938zm-2.041 0v-.937h1.1v.938zm-2.041 0v-.937h1.1v.938zm-2.043 0v-.937h1.105v.938zm-2.041 0v-.937h1.1v.938zm.938-4.219v-1.343h9.438v1.343zm5.188-2.28v-2.938h.938a1.408 1.408 0 0 0-1.406-1.406 1.408 1.408 0 0 0-1.406 1.406h.938v2.938h-2.812v-2.938h.938a1.408 1.408 0 0 0-1.406-1.406h-2.844a1.407 1.407 0 0 1-1.406-1.406 1.408 1.408 0 0 1 1.406-1.406h13.188a1.408 1.408 0 0 1 1.406 1.406 1.407 1.407 0 0 1-1.406 1.406h-2.844a1.408 1.408 0 0 0-1.406 1.406h.938v2.938z",
    transform: "translate(10451 8664)",
    style: {
      fill: "#808285"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallManufacturerGrey);
export default __webpack_public_path__ + "static/media/smallManufacturerGrey.fe412921.svg";
export { ForwardRef as ReactComponent };